import $ from "jquery";
import * as helpers from "../shared/find-a-store-helpers.js";
import "../shared/store-locator/jquery.storelocator.js";
import { mapStyle } from "./map-style.js";
import "url-polyfill";
var numLocations = 0;
function OnClickMarker(marker, markerId, selectedLocation, locationset) {
  // Re-order info to top of list when a marker is clicked
  //const item = $('li[data-markerid="' + markerId + '"]')
  //item.parent().prepend(item)
}

function OnFindNearest() {
  const resultCount = $(".store-listing").length;
  const searchLocation = $("#bh-sl-address").val().replace(/-/g, " ");
  const radioValue = $("input[name='bh-sl-maxdistance']:checked").val();

  $("#search-header").text(`${resultCount} ACE Stores Near ${searchLocation}`);

  //show no result message
  if (radioValue === "15") {
    //default radius is 15 miles
    $(".error-message-container").addClass("hidden");
  }
  if (resultCount === numLocations && radioValue !== "15") {
    $(".error-message-container").removeClass("hidden");
  }
  if (resultCount !== numLocations) {
    numLocations = resultCount;
    $(".error-message-container").addClass("hidden");
  }

  helpers.loadMoreStores();
}

function OnFormVals(addressInput, searchInput, distance, region) {
  // if(numLocations){
  // }
}

function OnNoResults(map, myOptions) {
  setTimeout(() => {
    map.setZoom(5);
  }, 50);
}

function getStateAndCity(url) {
  const sections = url.pathname.split("/");
  if (
    sections.length >= 4 &&
    sections[1] === "locations" &&
    sections[2] &&
    sections[3]
  ) {
    return {
      state: sections[2],
      city: sections[3],
    };
  }
  return null;
}

function toTitleCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join(" ");
}
getNearestStore();
$(".search-store-btn").on("click", function (e) {
  e.preventDefault();
  scrollToTop();
  $("#state-hero").addClass("hidden");
  $(".store-map-container").removeClass("hidden");
  getNearestStore();
  e.stopPropagation();
  return false;
});
function scrollToTop() {
  console.log("Scrolling to top...");
  $("html, body").animate({ scrollTop: 0 }, "slow", function () {
    console.log("Finished scrolling.");
  });
}
$(".find-store-button").on("click", function (e) {
  e.preventDefault();
  scrollToTop();
  $("#state-hero").addClass("hidden");
  $(".store-map-container").removeClass("hidden");
  getNearestStore();
  e.stopPropagation();
  return false;
});
$(".search-store-input").on("keypress", function (e) {
  if (e.which == 13) {
    $(".search-store-btn").click();
  }
});
export default function getNearestStore() {
  // Search string parameter
  const url_string = window.location.href;
  const url = new URL(url_string);
  const locationString = $(".search-store-input").val();
  const stateAndCity = getStateAndCity(url);
  let searchString, originParam, overrideOriginString;
  const homeStore = helpers.getHomeStore();
  let outMap = $(".store-map-container").hasClass("hidden");

  if (stateAndCity) {
    searchString = toTitleCase(
      "" + stateAndCity.city + ", " + stateAndCity.state
    );
    originParam = stateAndCity.state;
    overrideOriginString = toTitleCase(
      "" + stateAndCity.city + ", " + stateAndCity.state
    );
  } else {
    searchString = locationString;

    originParam = url.searchParams.get("origin");
    overrideOriginString = originParam || homeStore.origin;
  }

  window.helpers = helpers;

  if (outMap === false) {
    setTimeout(() => {
      var searchAddress = searchString.replace(/-/g, " ");
      $("#bh-sl-address").val(searchAddress);

      if ($("#bh-sl-map-container").storeLocator) {
        $("#bh-sl-map-container").storeLocator({
          debug: false,
          autoComplete: false,
          overrideOriginAddress: overrideOriginString,
          markerImg: "/assets/img/white-pin.svg",
          selectedMarkerImg: "/assets/img/map-pin.svg",
          letterColor: "#000000",
          letterColorSelected: "#ffffff",
          markerDim: { height: 42, width: 42 },
          selectedMarkerImgDim: { height: 42, width: 42 },
          disableListClicks: false,
          geocodeFailSearchString: "United States",
          originalZoom: 12,
          fullMapStart: false,
          autoGeocode: !(searchString || stateAndCity),
          pagination: false,
          disableAlphaMarkers: true,
          bounceMarker: false,
          openNearest: true,
          originMarker: true,
          originMarkerImg: "/locations/assets/img/marker-blue-dot.png",
          maxDistance: true,
          exclusiveFiltering: true,
          filters: {
            status: "C",
          },
          taxonomyFilters: {
            "services.name": "category-filters-container1",
            features: "category-filters-container2",
            city: "city-filter",
            postal: "postal-filter",
          },
          mapSettings: mapStyle,
          storeLimit: -1,
          dataLocation: "/locations/assets/data/stores.json",
          distanceAlert: -1,
          detailsTemplatePath:
            "/assets/find-a-store-templates/custom-templates/details.html",
          listTemplatePath:
            "/assets/find-a-store-templates/custom-templates/location-list-description.html",
          infowindowTemplatePath:
            "/assets/find-a-store-templates/custom-templates/infowindow-description.html",
          KMLinfowindowTemplatePath:
            "/assets/find-a-store-templates/custom-templates/kml-infowindow-description.html",
          KMLlistTemplatePath:
            "/assets/find-a-store-templates/custom-templates/kml-location-list-description.html",
          callbackNearestLoc: OnFindNearest,
          callbackMarkerClick: OnClickMarker,
          callbackNoResults: OnNoResults,
          callbackFormVals: OnFormVals,
          autoGeocodeErrorAlert: null,
          distanceErrorAlert: null,
        });
      }

      OnFindNearest();
    }, 500);
  }
}
